
















































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Mutations, Buttons, Actions } from '@/ts/store/Constants';
import DateMethods from '@/mixins/DateMethods.vue';
import PreviewTicketAttachments from '@/components/User/Panels/PreviewTicketAttachments.vue';
import TicketHelper from '@/mixins/TicketHelper.vue';
import TicketPriorityDropdown from '@/components/Admin/Lists/TicketPriorityDropdown.vue';
import DeviceMethods from '@/mixins/DeviceMethods.vue';

import { Keyboard } from '@capacitor/keyboard';

@Component({
    components: {
        PreviewTicketAttachments,
        TicketPriorityDropdown,
    },
    computed: {
        ...mapGetters({
            ticketAttachmentsOverlayVisibility: 'UserTickets/getTicketAttachmentsOverlayVisibility',
            ticketAllStates: 'Tickets/getTicketAllStates',
        }),
    },
})
export default class UserTicketsDetails extends Mixins(DateMethods, TicketHelper, DeviceMethods) {
    constructor() {
        super();

        this.initializeKeyboardListener();
    }

    get userCurrentTicket() {
        return this.$store.getters['UserTickets/getUserCurrentTicket'];
    }

    get ticketMedias() {
        return this.$store.getters['UserTickets/getActiveTicketImages'];
    }

    get ticketPriorityDropdownVisibility() {
        return this.$store.getters['UserTickets/getTicketPriorityDropdownVisibility'];
    }

    get hasMedias() {
        return typeof this.ticketMedias === 'undefined' ||  !this.ticketMedias.length;
    }

    @Watch('userCurrentTicket')
    public userCurrentTicketChanged() {
        this.$store.commit(Mutations.SET_HEADER_TEXT, `${this.$t('header.ticket', 'Ticket')} - #${this.userCurrentTicket.id}`);
    }

    public initializeKeyboardListener(): void {
        this.device().then((deviceInfo) => {
            if (deviceInfo.platform !== 'web') {
                Keyboard.setAccessoryBarVisible({ isVisible: true });
            }
        });
    }

    public showTicketAttachments() {
        if (typeof this.ticketMedias === 'undefined' ||  !this.ticketMedias.length) {
            return;
        }

        this.$store.commit(Mutations.SET_PREVIEW_TICKET_ATTACHMENTS_VISIBILITY, true);
    }

    public changeTicketState() {
        this.$store.dispatch(Actions.CHANGE_TICKET_STATE, this.userCurrentTicket);
    }

    public toggleTicketPriorityDropdown() {
        this.$store.commit(Mutations.TICKET_PRIORITY_DROPDOWN_VISIBILITY, !this.ticketPriorityDropdownVisibility);
    }

    public created() {
        this.$store.commit(Mutations.SET_LEFT_HEADER_BUTTON, Buttons.StaffBackButton);
        this.$store.commit(Mutations.SET_RIGHT_HEADER_BUTTON, Buttons.None);

        this.$store.commit(Mutations.SET_BOTTOM_MENU_VISIBILITY, false);
        this.$store.dispatch(Actions.FETCH_TICKET_ALL_STATES);
    }

    public mounted() {
        if (this.userCurrentTicket && this.$route.params.ticketId === this.userCurrentTicket.id) {
            return;
        }

        this.$store.dispatch(Actions.FETCH_USER_CURRENT_TICKET, {
            id: this.$route.params.ticketId,
            admin: true,
        });
    }

    public destroyed() {
        this.$store.commit(Mutations.SET_ACTIVE_TICKET_IMAGES, []);
    }
}
